import { Api, DateUtil, ModelRow, StringUtil } from "@mcleod/core";
import { Component, Snackbar, Table, Toast } from "@mcleod/components";
import { AutogenLayoutReportScheduleList } from "./autogen/AutogenLayoutReportScheduleList";

export class ReportScheduleList extends AutogenLayoutReportScheduleList {
    override onLoad() {
        this.tableList.addButtonCaption = "Add Report Schedule";
        this.buttonScheduleNow.enabledInTableHeader = this.buttonScheduleNowEnabledInTableHeader;
        this.mainDataSource.search({ is_active: "Y" });
    }

    private buttonScheduleNowEnabledInTableHeader = (_component: Component, table: Table): boolean => {
        return table.selectedRowCount === 1 &&
            (table.selectedRow.data as ModelRow).getDateTime("next_generate_date", null) != null;
    }

    async buttonScheduleNowOnClick() {
        if (this.tableList.selectedRowCount !== 1) {
            return;
        }
        const reportSchedule = this.tableList.selectedRow?.data;
        if (reportSchedule == null) {
            return;
        }
        const input = { id: reportSchedule.getString("id", null) };
        const response = await Api.post("common/reports/report-schedule-run-now", input);
        const nextGenerateDateString = response?.data[0]?.next_generate_date;
        const nextGenerateDate = !StringUtil.isEmptyString(nextGenerateDateString) ?
            DateUtil.parseDateTime(nextGenerateDateString) :
            undefined;
        if (nextGenerateDate != null) {
            reportSchedule.set("next_generate_date", nextGenerateDate);
            reportSchedule.resetOriginalData("next_generate_date");
            Toast.showSuccessToast("Report Sent", "Your report has been successfully sent.")
        } else {
            // We should never hit this...the button shouldn't be enabled when this is the case.  But just in case...
            Snackbar.showWarningSnackbar("The report could not be run.  Note that inactive reports cannot be run" +
                " remotely.  If an inactive report needs to be run remotely, make the report active (temporarily)." +
                "  This includes effective dates as well as the Active flag.");
        }
    }
}
